import script from "./MenuBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuBar.vue?vue&type=script&lang=ts&setup=true"

import "./MenuBar.vue?vue&type=style&index=0&id=27b17210&lang=scss"
import "./MenuBar.vue?vue&type=style&index=1&id=27b17210&lang=scss"

const __exports__ = script;

export default __exports__